<template>
  <li
    class="flex items-center p-2 hover:bg-surface-base"
    :id="`listbox-option-${value}`"
    @click="emitOptionChange(option)"
  >
    <SeatBulb v-if="hasIcon" :status="option.status" />
    <span class="capitalize" :class="{ 'ml-2': hasIcon }">{{ option[itemText] }}</span>
  </li>
</template>
<script lang="ts">
import { PropType, defineComponent } from 'vue'

import SeatBulb from '@/components/seat/SeatBulb.vue'

export default defineComponent({
  name: 'ListBoxOption',
  components: {
    SeatBulb,
  },
  props: {
    hasIcon: { type: Boolean, required: false, default: false },
    option: { type: Object as PropType<any>, required: true },
    itemText: { type: String, required: true },
    itemValue: { type: String, required: true },
  },
  methods: {
    emitOptionChange(option) {
      this.$emit('listBoxOptionChange', option)
    },
  },
  computed: {
    value(): string {
      return this.option[this.itemValue]
    },
  },
})
</script>
